import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { RefundPaymentDialogComponent } from './refund-payment-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { UzurvDirectivesModule } from '@uzurv/core';

@NgModule({
  declarations: [RefundPaymentDialogComponent],
  imports: [CommonModule, MatDialogModule, MatInputModule, MatButtonModule, FormsModule, UzurvDirectivesModule],
  exports: [RefundPaymentDialogComponent]
})
export class RefundPaymentDialogModule {}
